import { render, staticRenderFns } from "./Inp.vue?vue&type=template&id=3a012c24&scoped=true&"
import script from "./Inp.vue?vue&type=script&lang=js&"
export * from "./Inp.vue?vue&type=script&lang=js&"
import style0 from "./Inp.vue?vue&type=style&index=0&id=3a012c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a012c24",
  null
  
)

export default component.exports